var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 0C4.47721 0 6.10352e-05 4.47716 6.10352e-05 10V29.8266C6.10352e-05 35.3494 4.47722 39.8266 10.0001 39.8266H29.8267C35.3495 39.8266 39.8267 35.3494 39.8267 29.8266V10C39.8267 4.47715 35.3495 0 29.8266 0H10.0001ZM22.8313 24.4839V39.49H15.7523V24.4839H10.0005V18.0571H15.7523V13.1588C15.7523 7.58659 19.1342 4.50867 24.3086 4.50867C26.787 4.50867 29.3794 4.94287 29.3794 4.94287V10.4144H26.5229C23.7089 10.4144 22.8313 12.1282 22.8313 13.8864V18.0571H29.1139L28.1096 24.4839H22.8313Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialFacebook);
export default __webpack_public_path__ + "static/media/social-facebook.d18bc5a2d94af33c51aac30c4de91ba6.svg";
export { ForwardRef as ReactComponent };